"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var temp = function TabletTwoTone(primaryColor, secondaryColor) {
  return {
    name: 'tablet',
    theme: 'twotone',
    nameWithTheme: 'tablet-twotone',
    tag: 'svg',
    attrs: {
      xmlns: 'http://www.w3.org/2000/svg',
      class: 'icon',
      viewBox: '0 0 1024 1024'
    },
    children: [{
      tag: 'path',
      attrs: {
        fill: primaryColor,
        d: 'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: secondaryColor,
        d: 'M232 888h560V136H232v752zm280-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: primaryColor,
        d: 'M472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
      },
      children: []
    }]
  };
};
temp.nameWithTheme = 'tablet-twotone';
var TabletTwoTone = temp;
exports.default = TabletTwoTone;